<template>
  <header class="lg:flex overflow-hidden">
    <TitleBlock
      :subtitle="content.subtitle"
      :title="content.title"
      :description="content.description"
      :buttons="content.buttons"
      class="px-5 pt-8 lg:px-25 lg:pt-20 lg:pb-33.75 lg:w-[80dvw] lg:ml-0 lg:shrink-0 transition-[padding_width]"
    />
    <div
      class="relative -translate-y-[15%] lg:-translate-x-[30dvw] -mb-[15%] lg:mb-0 -z-10 lg:w-[60dvw] lg:-mr-[30dvw] lg:translate-y-0"
    >
      <div
        class="absolute bg-gradient-to-b from-white -top-[1px] lg:top-0 left-0 lg:-left-[1px] w-full h-[30%] lg:h-full lg:w-[70%] lg:bg-gradient-to-r"
      />
      <ResponsiveImage
        :media="content.image"
        class="md:max-h-[calc(80dvh)] lg:h-full lg:max-h-[calc(100dvh-108px)] w-full object-cover"
      />
    </div>
  </header>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { TitleBlock } from "@/components/blocks";
import { ResponsiveImage } from "@/components/helpers";

export default {
  name: "HomeHeader",
  components: { ResponsiveImage, TitleBlock },
  props: {
    content: {
      type: Object as PropType<HomeHeader>,
      required: true,
    },
  },
};
</script>
